import React, { useEffect, useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import { BiArrowBack } from 'react-icons/bi'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { db } from "../firebase-config";
import { collection, addDoc} from "firebase/firestore"; 
import "../styles/components/loader.css"
import { Link } from 'react-router-dom'

export function Form({preloadedValues}) {
  

      
        const { register, handleSubmit, setError, reset, formState: {errors, isSubmitting, isSubmitted, isSubmitSuccessful }  } = useForm({
            mode: 'onChange',
            defaultValues: "",
      })


   

      
      const formRef = useRef()
      const formRef2 = useRef()
      const mailCheckRef = useRef()

      const [submitionError, setSubmitionError] = useState(false)
      const [activeUser, setActiveUser] = useState();
      
      const [mailIsChecked, setmailChecked] = useState()
      const [validation, setValidation] = useState("")   
      const [isSelectedOne, setIsSelectedOne] = useState()
      const [isSelectedTwo, setIsSelectedTwo] = useState()
      const [isSelectedThree, setIsSelectedThree] = useState()
      
      const user1 = {
        id: preloadedValues[0].id,
        how: preloadedValues[0].how,
        howAutre: preloadedValues[0].howAutre,
        city: preloadedValues[0].city,
        sx:  preloadedValues[0].sx,
        situation: preloadedValues[0].situation,
        age: preloadedValues[0].age,
        qualification: preloadedValues[0].qualification,
        attente: preloadedValues[0].attente,
        // accept: preloadedValues[0].accept,
      };
      const user2 = {
        id: preloadedValues[1].id,
        how: preloadedValues[1].how,
        howAutre: preloadedValues[1].howAutre,
        city: preloadedValues[1].city,
        sx:  preloadedValues[1].sx,
        situation: preloadedValues[1].situation,
        age: preloadedValues[1].age,
        qualification: preloadedValues[1].qualification,
        attente: preloadedValues[1].attente,
        // accept: preloadedValues[0].accept,
      };
      const user3 = {
        id: preloadedValues[2].id,
        how: preloadedValues[2].how,
        howAutre: preloadedValues[2].howAutre,
        city: preloadedValues[2].city,
        sx:  preloadedValues[2].sx,
        situation: preloadedValues[2].situation,
        age: preloadedValues[2].age,
        qualification: preloadedValues[2].qualification,
        attente: preloadedValues[2].attente,
        // accept: preloadedValues[0].accept,
      };
      const user4 = {
        id: preloadedValues[3].id,
        how: preloadedValues[3].how,
        howAutre: preloadedValues[3].howAutre,
        city: preloadedValues[3].city,
        sx:  preloadedValues[3].sx,
        situation: preloadedValues[3].situation,
        age: preloadedValues[3].age,
        qualification: preloadedValues[3].qualification,
        attente: preloadedValues[3].attente,
        // accept: preloadedValues[0].accept,
      };
      const user5 = {
        id: preloadedValues[4].id,
        how: preloadedValues[4].how,
        howAutre: preloadedValues[4].howAutre,
        city: preloadedValues[4].city,
        sx:  preloadedValues[4].sx,
        situation: preloadedValues[4].situation,
        age: preloadedValues[4].age,
        qualification: preloadedValues[4].qualification,
        attente: preloadedValues[4].attente,
        // accept: preloadedValues[0].accept,
      };
      const user6 = {
        id: preloadedValues[5].id,
        how: preloadedValues[5].how,
        howAutre: preloadedValues[5].howAutre,
        city: preloadedValues[5].city,
        sx:  preloadedValues[5].sx,
        situation: preloadedValues[5].situation,
        age: preloadedValues[5].age,
        qualification: preloadedValues[5].qualification,
        attente: preloadedValues[5].attente,
        // accept: preloadedValues[0].accept,
      };
      const user7 = {
        id: preloadedValues[6].id,
        how: preloadedValues[6].how,
        howAutre: preloadedValues[6].howAutre,
        city: preloadedValues[6].city,
        sx:  preloadedValues[6].sx,
        situation: preloadedValues[6].situation,
        age: preloadedValues[6].age,
        qualification: preloadedValues[6].qualification,
        attente: preloadedValues[6].attente,
        // accept: preloadedValues[0].accept,
      };
      const user8 = {
        id: preloadedValues[7].id,
        how: preloadedValues[7].how,
        howAutre: preloadedValues[7].howAutre,
        city: preloadedValues[7].city,
        sx:  preloadedValues[7].sx,
        situation: preloadedValues[7].situation,
        age: preloadedValues[7].age,
        qualification: preloadedValues[7].qualification,
        attente: preloadedValues[7].attente,
        // accept: preloadedValues[0].accept,
      };
      const user9 = {
        id: preloadedValues[8].id,
        how: preloadedValues[8].how,
        howAutre: preloadedValues[8].howAutre,
        city: preloadedValues[8].city,
        sx:  preloadedValues[8].sx,
        situation: preloadedValues[8].situation,
        age: preloadedValues[8].age,
        qualification: preloadedValues[8].qualification,
        attente: preloadedValues[8].attente,
        // accept: preloadedValues[0].accept,
      };
      const user10 = {
        id: preloadedValues[9].id,
        how: preloadedValues[9].how,
        howAutre: preloadedValues[9].howAutre,
        city: preloadedValues[9].city,
        sx:  preloadedValues[9].sx,
        situation: preloadedValues[9].situation,
        age: preloadedValues[9].age,
        qualification: preloadedValues[9].qualification,
        attente: preloadedValues[9].attente,
        // accept: preloadedValues[0].accept,
      };
      const user11 = {
        id: preloadedValues[10].id,
        how: preloadedValues[10].how,
        howAutre: preloadedValues[10].howAutre,
        city: preloadedValues[10].city,
        sx:  preloadedValues[10].sx,
        situation: preloadedValues[10].situation,
        age: preloadedValues[10].age,
        qualification: preloadedValues[10].qualification,
        attente: preloadedValues[10].attente,
        // accept: preloadedValues[0].accept,
      };
      const user12 = {
        id: preloadedValues[11].id,
        how: preloadedValues[11].how,
        howAutre: preloadedValues[11].howAutre,
        city: preloadedValues[11].city,
        sx:  preloadedValues[11].sx,
        situation: preloadedValues[11].situation,
        age: preloadedValues[11].age,
        qualification: preloadedValues[11].qualification,
        attente: preloadedValues[11].attente,
        // accept: preloadedValues[0].accept,
      };
      const user13 = {
        id: preloadedValues[12].id,
        how: preloadedValues[12].how,
        howAutre: preloadedValues[12].howAutre,
        city: preloadedValues[12].city,
        sx:  preloadedValues[12].sx,
        situation: preloadedValues[12].situation,
        age: preloadedValues[12].age,
        qualification: preloadedValues[12].qualification,
        attente: preloadedValues[12].attente,
        // accept: preloadedValues[0].accept,
      };
      const user14 = {
        id: preloadedValues[13].id,
        how: preloadedValues[13].how,
        howAutre: preloadedValues[13].howAutre,
        city: preloadedValues[13].city,
        sx:  preloadedValues[13].sx,
        situation: preloadedValues[13].situation,
        age: preloadedValues[13].age,
        qualification: preloadedValues[13].qualification,
        attente: preloadedValues[13].attente,
        // accept: preloadedValues[0].accept,
      };
      const user15 = {
        id: preloadedValues[14].id,
        how: preloadedValues[14].how,
        howAutre: preloadedValues[14].howAutre,
        city: preloadedValues[14].city,
        sx:  preloadedValues[14].sx,
        situation: preloadedValues[14].situation,
        age: preloadedValues[14].age,
        qualification: preloadedValues[14].qualification,
        attente: preloadedValues[14].attente,
        // accept: preloadedValues[0].accept,
      };
      const user16 = {
        id: preloadedValues[15].id,
        how: preloadedValues[15].how,
        howAutre: preloadedValues[15].howAutre,
        city: preloadedValues[15].city,
        sx:  preloadedValues[15].sx,
        situation: preloadedValues[15].situation,
        age: preloadedValues[15].age,
        qualification: preloadedValues[15].qualification,
        attente: preloadedValues[15].attente,
        // accept: preloadedValues[0].accept,
      };
      const user17 = {
        id: preloadedValues[16].id,
        how: preloadedValues[16].how,
        howAutre: preloadedValues[16].howAutre,
        city: preloadedValues[16].city,
        sx:  preloadedValues[16].sx,
        situation: preloadedValues[16].situation,
        age: preloadedValues[16].age,
        qualification: preloadedValues[16].qualification,
        attente: preloadedValues[16].attente,
        // accept: preloadedValues[0].accept,
      };
      const user18 = {
        id: preloadedValues[17].id,
        how: preloadedValues[17].how,
        howAutre: preloadedValues[17].howAutre,
        city: preloadedValues[17].city,
        sx:  preloadedValues[17].sx,
        situation: preloadedValues[17].situation,
        age: preloadedValues[17].age,
        qualification: preloadedValues[17].qualification,
        attente: preloadedValues[17].attente,
        // accept: preloadedValues[0].accept,
      };
      const user19 = {
        id: preloadedValues[18].id,
        how: preloadedValues[18].how,
        howAutre: preloadedValues[18].howAutre,
        city: preloadedValues[18].city,
        sx:  preloadedValues[18].sx,
        situation: preloadedValues[18].situation,
        age: preloadedValues[18].age,
        qualification: preloadedValues[18].qualification,
        attente: preloadedValues[18].attente,
        // accept: preloadedValues[0].accept,
      };
      const user20 = {
        id: preloadedValues[19].id,
        how: preloadedValues[19].how,
        howAutre: preloadedValues[19].howAutre,
        city: preloadedValues[19].city,
        sx:  preloadedValues[19].sx,
        situation: preloadedValues[19].situation,
        age: preloadedValues[19].age,
        qualification: preloadedValues[19].qualification,
        attente: preloadedValues[19].attente,
        // accept: preloadedValues[0].accept,
      };
      const user21 = {
        id: preloadedValues[20].id,
        how: preloadedValues[20].how,
        howAutre: preloadedValues[20].howAutre,
        city: preloadedValues[20].city,
        sx:  preloadedValues[20].sx,
        situation: preloadedValues[20].situation,
        age: preloadedValues[20].age,
        qualification: preloadedValues[20].qualification,
        attente: preloadedValues[20].attente,
        // accept: preloadedValues[0].accept,
      };
      const user22 = {
        id: preloadedValues[21].id,
        how: preloadedValues[21].how,
        howAutre: preloadedValues[21].howAutre,
        city: preloadedValues[21].city,
        sx:  preloadedValues[21].sx,
        situation: preloadedValues[21].situation,
        age: preloadedValues[21].age,
        qualification: preloadedValues[21].qualification,
        attente: preloadedValues[21].attente,
        // accept: preloadedValues[0].accept,
      };
      const user23 = {
        id: preloadedValues[22].id,
        how: preloadedValues[22].how,
        howAutre: preloadedValues[22].howAutre,
        city: preloadedValues[22].city,
        sx:  preloadedValues[22].sx,
        situation: preloadedValues[22].situation,
        age: preloadedValues[22].age,
        qualification: preloadedValues[22].qualification,
        attente: preloadedValues[22].attente,
        // accept: preloadedValues[0].accept,
      };
      const user24 = {
        id: preloadedValues[23].id,
        how: preloadedValues[23].how,
        howAutre: preloadedValues[23].howAutre,
        city: preloadedValues[23].city,
        sx:  preloadedValues[23].sx,
        situation: preloadedValues[23].situation,
        age: preloadedValues[23].age,
        qualification: preloadedValues[23].qualification,
        attente: preloadedValues[23].attente,
        // accept: preloadedValues[0].accept,
      };
      const user25 = {
        id: preloadedValues[24].id,    
        how: preloadedValues[24].how,
        howAutre: preloadedValues[24].howAutre,
        city: preloadedValues[24].city,
        sx:  preloadedValues[24].sx,
        situation: preloadedValues[24].situation,
        age: preloadedValues[24].age,
        qualification: preloadedValues[24].qualification,
        attente: preloadedValues[24].attente,
        // accept: preloadedValues[0].accept,
      };
      const user26 = {
        id: preloadedValues[25].id,    
        how: preloadedValues[25].how,
        howAutre: preloadedValues[25].howAutre,
        city: preloadedValues[25].city,
        sx:  preloadedValues[25].sx,
        situation: preloadedValues[25].situation,
        age: preloadedValues[25].age,
        qualification: preloadedValues[25].qualification,
        attente: preloadedValues[25].attente,
        // accept: preloadedValues[0].accept,
      };
      const user27 = {
        id: preloadedValues[26].id,    
        how: preloadedValues[26].how,
        howAutre: preloadedValues[26].howAutre,
        city: preloadedValues[26].city,
        sx:  preloadedValues[26].sx,
        situation: preloadedValues[26].situation,
        age: preloadedValues[26].age,
        qualification: preloadedValues[6].qualification,
        attente: preloadedValues[26].attente,
        // accept: preloadedValues[0].accept,
      };
      const user28 = {
        id: preloadedValues[27].id,    
        how: preloadedValues[27].how,
        howAutre: preloadedValues[27].howAutre,
        city: preloadedValues[27].city,
        sx:  preloadedValues[27].sx,
        situation: preloadedValues[27].situation,
        age: preloadedValues[27].age,
        qualification: preloadedValues[27].qualification,
        attente: preloadedValues[27].attente,
        // accept: preloadedValues[0].accept,
      };
      const user29 = {
        id: preloadedValues[28].id,    
        how: preloadedValues[28].how,
        howAutre: preloadedValues[28].howAutre,
        city: preloadedValues[28].city,
        sx:  preloadedValues[28].sx,
        situation: preloadedValues[28].situation,
        age: preloadedValues[28].age,
        qualification: preloadedValues[28].qualification,
        attente: preloadedValues[28].attente,
        // accept: preloadedValues[0].accept,
      };
      const user30 = {
        id: preloadedValues[29].id,    
        how: preloadedValues[29].how,
        howAutre: preloadedValues[29].howAutre,
        city: preloadedValues[29].city,
        sx:  preloadedValues[29].sx,
        situation: preloadedValues[29].situation,
        age: preloadedValues[29].age,
        qualification: preloadedValues[29].qualification,
        attente: preloadedValues[29].attente,
        // accept: preloadedValues[0].accept,
      };
      const user31 = {
        id: preloadedValues[30].id,    
        how: preloadedValues[30].how,
        howAutre: preloadedValues[30].howAutre,
        city: preloadedValues[30].city,
        sx:  preloadedValues[30].sx,
        situation: preloadedValues[30].situation,
        age: preloadedValues[30].age,
        qualification: preloadedValues[30].qualification,
        attente: preloadedValues[30].attente,
        // accept: preloadedValues[0].accept,
      };
      const user32 = {
        id: preloadedValues[31].id,    
        how: preloadedValues[31].how,
        howAutre: preloadedValues[31].howAutre,
        city: preloadedValues[31].city,
        sx:  preloadedValues[31].sx,
        situation: preloadedValues[31].situation,
        age: preloadedValues[31].age,
        qualification: preloadedValues[31].qualification,
        attente: preloadedValues[31].attente,
        // accept: preloadedValues[0].accept,
      };
      const user33 = {
        id: preloadedValues[32].id,    
        how: preloadedValues[32].how,
        howAutre: preloadedValues[32].howAutre,
        city: preloadedValues[32].city,
        sx:  preloadedValues[32].sx,
        situation: preloadedValues[32].situation,
        age: preloadedValues[32].age,
        qualification: preloadedValues[32].qualification,
        attente: preloadedValues[32].attente,
        // accept: preloadedValues[0].accept,
      };
      const user34 = {
        id: preloadedValues[33].id,    
        how: preloadedValues[33].how,
        howAutre: preloadedValues[33].howAutre,
        city: preloadedValues[33].city,
        sx:  preloadedValues[33].sx,
        situation: preloadedValues[33].situation,
        age: preloadedValues[33].age,
        qualification: preloadedValues[33].qualification,
        attente: preloadedValues[33].attente,
        // accept: preloadedValues[0].accept,
      };
      const user35 = {
        id: preloadedValues[34].id,    
        how: preloadedValues[34].how,
        howAutre: preloadedValues[34].howAutre,
        city: preloadedValues[34].city,
        sx:  preloadedValues[34].sx,
        situation: preloadedValues[34].situation,
        age: preloadedValues[34].age,
        qualification: preloadedValues[34].qualification,
        attente: preloadedValues[34].attente,
        // accept: preloadedValues[0].accept,
      };
      const user36 = {
        id: preloadedValues[35].id,    
        how: preloadedValues[35].how,
        howAutre: preloadedValues[35].howAutre,
        city: preloadedValues[35].city,
        sx:  preloadedValues[35].sx,
        situation: preloadedValues[35].situation,
        age: preloadedValues[35].age,
        qualification: preloadedValues[35].qualification,
        attente: preloadedValues[35].attente,
        // accept: preloadedValues[0].accept,
      };
      const user37 = {
        id: preloadedValues[36].id,    
        how: preloadedValues[36].how,
        howAutre: preloadedValues[36].howAutre,
        city: preloadedValues[36].city,
        sx:  preloadedValues[36].sx,
        situation: preloadedValues[36].situation,
        age: preloadedValues[36].age,
        qualification: preloadedValues[36].qualification,
        attente: preloadedValues[36].attente,
        // accept: preloadedValues[0].accept,
      };
      const user38 = {
        id: preloadedValues[37].id,    
        how: preloadedValues[37].how,
        howAutre: preloadedValues[37].howAutre,
        city: preloadedValues[37].city,
        sx:  preloadedValues[37].sx,
        situation: preloadedValues[37].situation,
        age: preloadedValues[37].age,
        qualification: preloadedValues[37].qualification,
        attente: preloadedValues[37].attente,
        // accept: preloadedValues[0].accept,
      };
      const user39 = {
        id: preloadedValues[38].id,    
        how: preloadedValues[38].how,
        howAutre: preloadedValues[38].howAutre,
        city: preloadedValues[38].city,
        sx:  preloadedValues[38].sx,
        situation: preloadedValues[38].situation,
        age: preloadedValues[38].age,
        qualification: preloadedValues[38].qualification,
        attente: preloadedValues[38].attente,
        // accept: preloadedValues[0].accept,
      };
      const user40 = {
        id: preloadedValues[39].id,    
        how: preloadedValues[39].how,
        howAutre: preloadedValues[39].howAutre,
        city: preloadedValues[39].city,
        sx:  preloadedValues[39].sx,
        situation: preloadedValues[39].situation,
        age: preloadedValues[39].age,
        qualification: preloadedValues[39].qualification,
        attente: preloadedValues[39].attente,
        // accept: preloadedValues[0].accept,
      };
      const user41 = {
        id: preloadedValues[40].id,    
        how: preloadedValues[40].how,
        howAutre: preloadedValues[40].howAutre,
        city: preloadedValues[40].city,
        sx:  preloadedValues[40].sx,
        situation: preloadedValues[40].situation,
        age: preloadedValues[40].age,
        qualification: preloadedValues[40].qualification,
        attente: preloadedValues[40].attente,
        // accept: preloadedValues[0].accept,
      };
      const user42 = {
        id: preloadedValues[41].id,    
        how: preloadedValues[41].how,
        howAutre: preloadedValues[41].howAutre,
        city: preloadedValues[41].city,
        sx:  preloadedValues[41].sx,
        situation: preloadedValues[41].situation,
        age: preloadedValues[41].age,
        qualification: preloadedValues[41].qualification,
        attente: preloadedValues[41].attente,
        // accept: preloadedValues[0].accept,
      };
      const user43 = {
        id: preloadedValues[42].id,    
        how: preloadedValues[42].how,
        howAutre: preloadedValues[42].howAutre,
        city: preloadedValues[42].city,
        sx:  preloadedValues[42].sx,
        situation: preloadedValues[42].situation,
        age: preloadedValues[42].age,
        qualification: preloadedValues[42].qualification,
        attente: preloadedValues[42].attente,
        // accept: preloadedValues[0].accept,
      };
      const user44 = {
        id: preloadedValues[43].id,    
        how: preloadedValues[43].how,
        howAutre: preloadedValues[43].howAutre,
        city: preloadedValues[43].city,
        sx:  preloadedValues[43].sx,
        situation: preloadedValues[43].situation,
        age: preloadedValues[43].age,
        qualification: preloadedValues[43].qualification,
        attente: preloadedValues[43].attente,
        // accept: preloadedValues[0].accept,
      };
      const user45 = {
        id: preloadedValues[44].id,    
        how: preloadedValues[44].how,
        howAutre: preloadedValues[44].howAutre,
        city: preloadedValues[44].city,
        sx:  preloadedValues[44].sx,
        situation: preloadedValues[44].situation,
        age: preloadedValues[44].age,
        qualification: preloadedValues[44].qualification,
        attente: preloadedValues[44].attente,
        // accept: preloadedValues[0].accept,
      };
      const user46 = {
        id: preloadedValues[45].id,    
        how: preloadedValues[45].how,
        howAutre: preloadedValues[45].howAutre,
        city: preloadedValues[45].city,
        sx:  preloadedValues[45].sx,
        situation: preloadedValues[45].situation,
        age: preloadedValues[45].age,
        qualification: preloadedValues[45].attente,
        // accept: preloadedValues[0].accept,
      };
      const user47 = {
        id: preloadedValues[46].id,    
        how: preloadedValues[46].how,
        howAutre: preloadedValues[46].howAutre,
        city: preloadedValues[46].city,
        sx:  preloadedValues[46].sx,
        situation: preloadedValues[46].situation,
        age: preloadedValues[46].age,
        qualification: preloadedValues[46].qualification,
        attente: preloadedValues[46].attente,
        // accept: preloadedValues[0].accept,
      };
      const user48 = {
        id: preloadedValues[47].id,    
        how: preloadedValues[47].how,
        howAutre: preloadedValues[47].howAutre,
        city: preloadedValues[47].city,
        sx:  preloadedValues[47].sx,
        situation: preloadedValues[47].situation,
        age: preloadedValues[47].age,
        qualification: preloadedValues[47].qualification,
        attente: preloadedValues[47].attente,
        // accept: preloadedValues[0].accept,
      };
      const user49 = {
        id: preloadedValues[48].id,    
        how: preloadedValues[48].how,
        howAutre: preloadedValues[48].howAutre,
        city: preloadedValues[48].city,
        sx:  preloadedValues[48].sx,
        situation: preloadedValues[48].situation,
        age: preloadedValues[48].age,
        qualification: preloadedValues[48].qualification,
        attente: preloadedValues[48].attente,
        // accept: preloadedValues[0].accept,
      };
      const user50 = {
        id: preloadedValues[49].id,    
        how: preloadedValues[49].how,
        howAutre: preloadedValues[49].howAutre,
        city: preloadedValues[49].city,
        sx:  preloadedValues[49].sx,
        situation: preloadedValues[49].situation,
        age: preloadedValues[49].age,
        qualification: preloadedValues[49].qualification,
        attente: preloadedValues[49].attente,
        // accept: preloadedValues[0].accept,
      };
      const user51 = {
        id: preloadedValues[50].id,    
        how: preloadedValues[50].how,
        howAutre: preloadedValues[50].howAutre,
        city: preloadedValues[50].city,
        sx:  preloadedValues[50].sx,
        situation: preloadedValues[50].situation,
        age: preloadedValues[50].age,
        qualification: preloadedValues[50].qualification,
        attente: preloadedValues[50].attente,
        // accept: preloadedValues[0].accept,
      };
      const user52 = {
        id: preloadedValues[51].id,    
        how: preloadedValues[51].how,
        howAutre: preloadedValues[51].howAutre,
        city: preloadedValues[51].city,
        sx:  preloadedValues[51].sx,
        situation: preloadedValues[51].situation,
        age: preloadedValues[51].age,
        qualification: preloadedValues[51].qualification,
        attente: preloadedValues[51].attente,
        // accept: preloadedValues[0].accept,
      };
      const user53 = {
        id: preloadedValues[52].id,    
        how: preloadedValues[52].how,
        howAutre: preloadedValues[52].howAutre,
        city: preloadedValues[52].city,
        sx:  preloadedValues[52].sx,
        situation: preloadedValues[52].situation,
        age: preloadedValues[52].age,
        qualification: preloadedValues[52].qualification,
        attente: preloadedValues[52].attente,
        // accept: preloadedValues[0].accept,
      };
      const user54 = {
        id: preloadedValues[53].id,    
        how: preloadedValues[53].how,
        howAutre: preloadedValues[53].howAutre,
        city: preloadedValues[53].city,
        sx:  preloadedValues[53].sx,
        situation: preloadedValues[53].situation,
        age: preloadedValues[53].age,
        qualification: preloadedValues[53].qualification,
        attente: preloadedValues[53].attente,
        // accept: preloadedValues[0].accept,
      };
      const user55 = {
        id: preloadedValues[54].id,    
        how: preloadedValues[54].how,
        howAutre: preloadedValues[54].howAutre,
        city: preloadedValues[54].city,
        sx:  preloadedValues[54].sx,
        situation: preloadedValues[54].situation,
        age: preloadedValues[54].age,
        qualification: preloadedValues[54].qualification,
        attente: preloadedValues[54].attente,
        // accept: preloadedValues[0].accept,
      };
      const user56 = {
        id: preloadedValues[55].id,    
        how: preloadedValues[55].how,
        howAutre: preloadedValues[55].howAutre,
        city: preloadedValues[55].city,
        sx:  preloadedValues[55].sx,
        situation: preloadedValues[55].situation,
        age: preloadedValues[55].age,
        qualification: preloadedValues[55].qualification,
        attente: preloadedValues[55].attente,
        // accept: preloadedValues[0].accept,
      };
      const user57 = {
        id: preloadedValues[56].id,    
        how: preloadedValues[56].how,
        howAutre: preloadedValues[56].howAutre,
        city: preloadedValues[56].city,
        sx:  preloadedValues[56].sx,
        situation: preloadedValues[56].situation,
        age: preloadedValues[56].age,
        qualification: preloadedValues[56].qualification,
        attente: preloadedValues[56].attente,
        // accept: preloadedValues[0].accept,
      };
      const user58 = {
        id: preloadedValues[57].id,    
        how: preloadedValues[57].how,
        howAutre: preloadedValues[57].howAutre,
        city: preloadedValues[57].city,
        sx:  preloadedValues[57].sx,
        situation: preloadedValues[57].situation,
        age: preloadedValues[57].age,
        qualification: preloadedValues[57].qualification,
        attente: preloadedValues[57].attente,
        // accept: preloadedValues[0].accept,
      };
      const user59 = {
        id: preloadedValues[58].id,    
        how: preloadedValues[58].how,
        howAutre: preloadedValues[58].howAutre,
        city: preloadedValues[58].city,
        sx:  preloadedValues[58].sx,
        situation: preloadedValues[58].situation,
        age: preloadedValues[58].age,
        qualification: preloadedValues[58].qualification,
        attente: preloadedValues[58].attente,
        // accept: preloadedValues[0].accept,
      };
      const user60 = {
        id: preloadedValues[59].id,    
        how: preloadedValues[59].how,
        howAutre: preloadedValues[59].howAutre,
        city: preloadedValues[59].city,
        sx:  preloadedValues[59].sx,
        situation: preloadedValues[59].situation,
        age: preloadedValues[59].age,
        qualification: preloadedValues[59].qualification,
        attente: preloadedValues[59].attente,
        // accept: preloadedValues[0].accept,
      };
      const user61 = {
        id: preloadedValues[60].id,    
        how: preloadedValues[60].how,
        howAutre: preloadedValues[60].howAutre,
        city: preloadedValues[60].city,
        sx:  preloadedValues[60].sx,
        situation: preloadedValues[60].situation,
        age: preloadedValues[60].age,
        qualification: preloadedValues[60].qualification,
        attente: preloadedValues[60].attente,
        // accept: preloadedValues[0].accept,
      };
      const user62 = {
        id: preloadedValues[61].id,    
        how: preloadedValues[61].how,
        howAutre: preloadedValues[61].howAutre,
        city: preloadedValues[61].city,
        sx:  preloadedValues[61].sx,
        situation: preloadedValues[61].situation,
        age: preloadedValues[61].age,
        qualification: preloadedValues[61].qualification,
        attente: preloadedValues[61].attente,
        // accept: preloadedValues[0].accept,
      };
      const user63 = {
        id: preloadedValues[62].id,    
        how: preloadedValues[62].how,
        howAutre: preloadedValues[62].howAutre,
        city: preloadedValues[62].city,
        sx:  preloadedValues[62].sx,
        situation: preloadedValues[62].situation,
        age: preloadedValues[62].age,
        qualification: preloadedValues[62].qualification,
        attente: preloadedValues[62].attente,
        // accept: preloadedValues[0].accept,
      };
      const user64 = {
        id: preloadedValues[63].id,    
        how: preloadedValues[63].how,
        howAutre: preloadedValues[63].howAutre,
        city: preloadedValues[63].city,
        sx:  preloadedValues[63].sx,
        situation: preloadedValues[63].situation,
        age: preloadedValues[63].age,
        qualification: preloadedValues[63].qualification,
        attente: preloadedValues[63].attente,
        // accept: preloadedValues[0].accept,
      };
      const user65 = {
        id: preloadedValues[64].id,    
        how: preloadedValues[64].how,
        howAutre: preloadedValues[64].howAutre,
        city: preloadedValues[64].city,
        sx:  preloadedValues[64].sx,
        situation: preloadedValues[64].situation,
        age: preloadedValues[64].age,
        qualification: preloadedValues[64].qualification,
        attente: preloadedValues[64].attente,
        // accept: preloadedValues[0].accept,
      };
      const user66 = {
        id: preloadedValues[65].id,    
        how: preloadedValues[65].how,
        howAutre: preloadedValues[65].howAutre,
        city: preloadedValues[65].city,
        sx:  preloadedValues[65].sx,
        situation: preloadedValues[65].situation,
        age: preloadedValues[65].age,
        qualification: preloadedValues[65].qualification,
        attente: preloadedValues[65].attente,
        // accept: preloadedValues[0].accept,
      };
      const user67 = {
        id: preloadedValues[66].id,    
        how: preloadedValues[66].how,
        howAutre: preloadedValues[66].howAutre,
        city: preloadedValues[66].city,
        sx:  preloadedValues[66].sx,
        situation: preloadedValues[66].situation,
        age: preloadedValues[66].age,
        qualification: preloadedValues[66].qualification,
        attente: preloadedValues[66].attente,
        // accept: preloadedValues[0].accept,
      };
      const user68 = {
        id: preloadedValues[67].id,    
        how: preloadedValues[67].how,
        howAutre: preloadedValues[67].howAutre,
        city: preloadedValues[67].city,
        sx:  preloadedValues[67].sx,
        situation: preloadedValues[67].situation,
        age: preloadedValues[67].age,
        qualification: preloadedValues[67].qualification,
        attente: preloadedValues[67].attente,
        // accept: preloadedValues[0].accept,
      };
      const user69 = {
        id: preloadedValues[68].id,    
        how: preloadedValues[68].how,
        howAutre: preloadedValues[68].howAutre,
        city: preloadedValues[68].city,
        sx:  preloadedValues[68].sx,
        situation: preloadedValues[68].situation,
        age: preloadedValues[68].age,
        qualification: preloadedValues[68].qualification,
        attente: preloadedValues[68].attente,
        // accept: preloadedValues[0].accept,
      };
      const user70 = {
        id: preloadedValues[69].id,    
        how: preloadedValues[69].how,
        howAutre: preloadedValues[69].howAutre,
        city: preloadedValues[69].city,
        sx:  preloadedValues[69].sx,
        situation: preloadedValues[69].situation,
        age: preloadedValues[69].age,
        qualification: preloadedValues[69].qualification,
        attente: preloadedValues[69].attente,
        // accept: preloadedValues[0].accept,
      };
      const user71 = {
        id: preloadedValues[70].id,    
        how: preloadedValues[70].how,
        howAutre: preloadedValues[70].howAutre,
        city: preloadedValues[70].city,
        sx:  preloadedValues[70].sx,
        situation: preloadedValues[70].situation,
        age: preloadedValues[70].age,
        qualification: preloadedValues[70].qualification,
        attente: preloadedValues[70].attente,
        // accept: preloadedValues[0].accept,
      };
      const user72 = {
        id: preloadedValues[71].id,    
        how: preloadedValues[71].how,
        howAutre: preloadedValues[71].howAutre,
        city: preloadedValues[71].city,
        sx:  preloadedValues[71].sx,
        situation: preloadedValues[71].situation,
        age: preloadedValues[71].age,
        qualification: preloadedValues[71].qualification,
        attente: preloadedValues[71].attente,
        // accept: preloadedValues[0].accept,
      };
      const user73 = {
        id: preloadedValues[72].id,    
        how: preloadedValues[72].how,
        howAutre: preloadedValues[72].howAutre,
        city: preloadedValues[72].city,
        sx:  preloadedValues[72].sx,
        situation: preloadedValues[72].situation,
        age: preloadedValues[72].age,
        qualification: preloadedValues[72].qualification,
        attente: preloadedValues[72].attente,
        // accept: preloadedValues[0].accept,
      };
      const user74 = {
        id: preloadedValues[73].id,    
        how: preloadedValues[73].how,
        howAutre: preloadedValues[73].howAutre,
        city: preloadedValues[73].city,
        sx:  preloadedValues[73].sx,
        situation: preloadedValues[73].situation,
        age: preloadedValues[73].age,
        qualification: preloadedValues[73].qualification,
        attente: preloadedValues[73].attente,
        // accept: preloadedValues[0].accept,
      };
      const user75 = {
        id: preloadedValues[74].id,    
        how: preloadedValues[74].how,
        howAutre: preloadedValues[74].howAutre,
        city: preloadedValues[74].city,
        sx:  preloadedValues[74].sx,
        situation: preloadedValues[74].situation,
        age: preloadedValues[74].age,
        qualification: preloadedValues[74].qualification,
        attente: preloadedValues[74].attente,
        // accept: preloadedValues[0].accept,
      };
      const user76 = {
        id: preloadedValues[75].id,    
        how: preloadedValues[75].how,
        howAutre: preloadedValues[75].howAutre,
        city: preloadedValues[75].city,
        sx:  preloadedValues[75].sx,
        situation: preloadedValues[75].situation,
        age: preloadedValues[75].age,
        qualification: preloadedValues[75].qualification,
        attente: preloadedValues[75].attente,
        // accept: preloadedValues[0].accept,
      };
      const user77 = {
        id: preloadedValues[76].id,    
        how: preloadedValues[76].how,
        howAutre: preloadedValues[76].howAutre,
        city: preloadedValues[76].city,
        sx:  preloadedValues[76].sx,
        situation: preloadedValues[76].situation,
        age: preloadedValues[76].age,
        qualification: preloadedValues[76].qualification,
        attente: preloadedValues[76].attente,
        // accept: preloadedValues[0].accept,
      };
      const user78 = {
        id: preloadedValues[77].id,    
        how: preloadedValues[77].how,
        howAutre: preloadedValues[77].howAutre,
        city: preloadedValues[77].city,
        sx:  preloadedValues[77].sx,
        situation: preloadedValues[77].situation,
        age: preloadedValues[77].age,
        qualification: preloadedValues[77].qualification,
        attente: preloadedValues[77].attente,
        // accept: preloadedValues[0].accept,
      };
      const user79 = {
        id: preloadedValues[78].id,    
        how: preloadedValues[78].how,
        howAutre: preloadedValues[78].howAutre,
        city: preloadedValues[78].city,
        sx:  preloadedValues[78].sx,
        situation: preloadedValues[78].situation,
        age: preloadedValues[78].age,
        qualification: preloadedValues[78].qualification,
        attente: preloadedValues[78].attente,
        // accept: preloadedValues[0].accept,
      };
      const user80 = {
        id: preloadedValues[79].id,    
        how: preloadedValues[79].how,
        howAutre: preloadedValues[79].howAutre,
        city: preloadedValues[79].city,
        sx:  preloadedValues[79].sx,
        situation: preloadedValues[79].situation,
        age: preloadedValues[79].age,
        qualification: preloadedValues[79].qualification,
        attente: preloadedValues[79].attente,
        // accept: preloadedValues[0].accept,
      };
      const user81 = {
        id: preloadedValues[80].id,    
        how: preloadedValues[80].how,
        howAutre: preloadedValues[80].howAutre,
        city: preloadedValues[80].city,
        sx:  preloadedValues[80].sx,
        situation: preloadedValues[80].situation,
        age: preloadedValues[80].age,
        qualification: preloadedValues[80].qualification,
        attente: preloadedValues[80].attente,
        // accept: preloadedValues[0].accept,
      };
      const user82 = {
        id: preloadedValues[81].id,    
        how: preloadedValues[81].how,
        howAutre: preloadedValues[81].howAutre,
        city: preloadedValues[81].city,
        sx:  preloadedValues[81].sx,
        situation: preloadedValues[81].situation,
        age: preloadedValues[81].age,
        qualification: preloadedValues[81].qualification,
        attente: preloadedValues[81].attente,
        // accept: preloadedValues[0].accept,
      };
      const user83 = {
        id: preloadedValues[82].id,    
        how: preloadedValues[82].how,
        howAutre: preloadedValues[82].howAutre,
        city: preloadedValues[82].city,
        sx:  preloadedValues[82].sx,
        situation: preloadedValues[82].situation,
        age: preloadedValues[82].age,
        qualification: preloadedValues[82].qualification,
        attente: preloadedValues[82].attente,
        // accept: preloadedValues[0].accept,
      };
      const user84 = {
        id: preloadedValues[83].id,    
        how: preloadedValues[83].how,
        howAutre: preloadedValues[83].howAutre,
        city: preloadedValues[83].city,
        sx:  preloadedValues[83].sx,
        situation: preloadedValues[83].situation,
        age: preloadedValues[83].age,
        qualification: preloadedValues[83].qualification,
        attente: preloadedValues[83].attente,
        // accept: preloadedValues[0].accept,
      };
      const user85 = {
        id: preloadedValues[84].id,    
        how: preloadedValues[84].how,
        howAutre: preloadedValues[84].howAutre,
        city: preloadedValues[84].city,
        sx:  preloadedValues[84].sx,
        situation: preloadedValues[84].situation,
        age: preloadedValues[84].age,
        qualification: preloadedValues[84].qualification,
        attente: preloadedValues[84].attente,
        // accept: preloadedValues[0].accept,
      };
      const user86 = {
        id: preloadedValues[85].id,    
        how: preloadedValues[85].how,
        howAutre: preloadedValues[85].howAutre,
        city: preloadedValues[85].city,
        sx:  preloadedValues[85].sx,
        situation: preloadedValues[85].situation,
        age: preloadedValues[85].age,
        qualification: preloadedValues[85].qualification,
        attente: preloadedValues[85].attente,
        // accept: preloadedValues[0].accept,
      };
      const user87 = {
        id: preloadedValues[86].id,    
        how: preloadedValues[86].how,
        howAutre: preloadedValues[86].howAutre,
        city: preloadedValues[86].city,
        sx:  preloadedValues[86].sx,
        situation: preloadedValues[86].situation,
        age: preloadedValues[86].age,
        qualification: preloadedValues[86].qualification,
        attente: preloadedValues[86].attente,
        // accept: preloadedValues[0].accept,
      };
      const user88 = {
        id: preloadedValues[87].id,    
        how: preloadedValues[87].how,
        howAutre: preloadedValues[87].howAutre,
        city: preloadedValues[87].city,
        sx:  preloadedValues[87].sx,
        situation: preloadedValues[87].situation,
        age: preloadedValues[87].age,
        qualification: preloadedValues[87].qualification,
        attente: preloadedValues[87].attente,
        // accept: preloadedValues[0].accept,
      };
      const user89 = {
        id: preloadedValues[88].id,    
        how: preloadedValues[88].how,
        howAutre: preloadedValues[88].howAutre,
        city: preloadedValues[88].city,
        sx:  preloadedValues[88].sx,
        situation: preloadedValues[88].situation,
        age: preloadedValues[88].age,
        qualification: preloadedValues[88].qualification,
        attente: preloadedValues[88].attente,
        // accept: preloadedValues[0].accept,
      };
      const user90 = {
        id: preloadedValues[89].id,    
        how: preloadedValues[89].how,
        howAutre: preloadedValues[89].howAutre,
        city: preloadedValues[89].city,
        sx:  preloadedValues[89].sx,
        situation: preloadedValues[89].situation,
        age: preloadedValues[89].age,
        qualification: preloadedValues[89].qualification,
        attente: preloadedValues[89].attente,
        // accept: preloadedValues[0].accept,
      };
      const user91 = {
        id: preloadedValues[90].id,    
        how: preloadedValues[90].how,
        howAutre: preloadedValues[90].howAutre,
        city: preloadedValues[90].city,
        sx:  preloadedValues[90].sx,
        situation: preloadedValues[90].situation,
        age: preloadedValues[90].age,
        qualification: preloadedValues[90].qualification,
        attente: preloadedValues[90].attente,
        // accept: preloadedValues[0].accept,
      };
      const user92 = {
        id: preloadedValues[91].id,    
        how: preloadedValues[91].how,
        howAutre: preloadedValues[91].howAutre,
        city: preloadedValues[91].city,
        sx:  preloadedValues[91].sx,
        situation: preloadedValues[91].situation,
        age: preloadedValues[91].age,
        qualification: preloadedValues[91].qualification,
        attente: preloadedValues[91].attente,
        // accept: preloadedValues[0].accept,
      };
      const user93 = {
        id: preloadedValues[92].id,    
        how: preloadedValues[92].how,
        howAutre: preloadedValues[92].howAutre,
        city: preloadedValues[92].city,
        sx:  preloadedValues[92].sx,
        situation: preloadedValues[92].situation,
        age: preloadedValues[92].age,
        qualification: preloadedValues[92].qualification,
        attente: preloadedValues[92].attente,
        // accept: preloadedValues[0].accept,
      };
      const user94 = {
        id: preloadedValues[93].id,    
        how: preloadedValues[93].how,
        howAutre: preloadedValues[93].howAutre,
        city: preloadedValues[93].city,
        sx:  preloadedValues[93].sx,
        situation: preloadedValues[93].situation,
        age: preloadedValues[93].age,
        qualification: preloadedValues[93].qualification,
        attente: preloadedValues[93].attente,
        // accept: preloadedValues[0].accept,
      };
      const user95 = {
        id: preloadedValues[94].id,    
        how: preloadedValues[94].how,
        howAutre: preloadedValues[94].howAutre,
        city: preloadedValues[94].city,
        sx:  preloadedValues[94].sx,
        situation: preloadedValues[94].situation,
        age: preloadedValues[94].age,
        qualification: preloadedValues[94].qualification,
        attente: preloadedValues[94].attente,
        // accept: preloadedValues[0].accept,
      };
      const user96 = {
        id: preloadedValues[95].id,    
        how: preloadedValues[95].how,
        howAutre: preloadedValues[95].howAutre,
        city: preloadedValues[95].city,
        sx:  preloadedValues[95].sx,
        situation: preloadedValues[95].situation,
        age: preloadedValues[95].age,
        qualification: preloadedValues[95].qualification,
        attente: preloadedValues[95].attente,
        // accept: preloadedValues[0].accept,
      };
      const user97 = {
        id: preloadedValues[96].id,    
        how: preloadedValues[96].how,
        howAutre: preloadedValues[96].howAutre,
        city: preloadedValues[96].city,
        sx:  preloadedValues[96].sx,
        situation: preloadedValues[96].situation,
        age: preloadedValues[96].age,
        qualification: preloadedValues[96].qualification,
        attente: preloadedValues[96].attente,
        // accept: preloadedValues[0].accept,
      };
      const user98 = {
        id: preloadedValues[97].id,    
        how: preloadedValues[97].how,
        howAutre: preloadedValues[97].howAutre,
        city: preloadedValues[97].city,
        sx:  preloadedValues[97].sx,
        situation: preloadedValues[97].situation,
        age: preloadedValues[97].age,
        qualification: preloadedValues[97].qualification,
        attente: preloadedValues[97].attente,
        // accept: preloadedValues[0].accept,
      };
      const user99 = {
        id: preloadedValues[98].id,    
        how: preloadedValues[98].how,
        howAutre: preloadedValues[98].howAutre,
        city: preloadedValues[98].city,
        sx:  preloadedValues[98].sx,
        situation: preloadedValues[98].situation,
        age: preloadedValues[98].age,
        qualification: preloadedValues[98].qualification,
        attente: preloadedValues[98].attente,
        // accept: preloadedValues[0].accept,
      };
      const user100 = {
        id: preloadedValues[99].id,    
        how: preloadedValues[99].how,
        howAutre: preloadedValues[99].howAutre,
        city: preloadedValues[99].city,
        sx:  preloadedValues[99].sx,
        situation: preloadedValues[99].situation,
        age: preloadedValues[99].age,
        qualification: preloadedValues[99].qualification,
        attente: preloadedValues[99].attente,
        // accept: preloadedValues[0].accept,
      };
      const user101 = {
        id: preloadedValues[100].id,    
        how: preloadedValues[100].how,
        howAutre: preloadedValues[100].howAutre,
        city: preloadedValues[100].city,
        sx:  preloadedValues[100].sx,
        situation: preloadedValues[100].situation,
        age: preloadedValues[100].age,
        qualification: preloadedValues[100].qualification,
        attente: preloadedValues[100].attente,
        // accept: preloadedValues[0].accept,
      };
      const user102 = {
        id: preloadedValues[101].id,    
        how: preloadedValues[101].how,
        howAutre: preloadedValues[101].howAutre,
        city: preloadedValues[101].city,
        sx:  preloadedValues[101].sx,
        situation: preloadedValues[101].situation,
        age: preloadedValues[101].age,
        qualification: preloadedValues[101].qualification,
        attente: preloadedValues[101].attente,
        // accept: preloadedValues[0].accept,
      };
      const user103 = {
        id: preloadedValues[102].id,    
        how: preloadedValues[102].how,
        howAutre: preloadedValues[102].howAutre,
        city: preloadedValues[102].city,
        sx:  preloadedValues[102].sx,
        situation: preloadedValues[102].situation,
        age: preloadedValues[102].age,
        qualification: preloadedValues[102].qualification,
        attente: preloadedValues[102].attente,
        // accept: preloadedValues[0].accept,
      };
      const user104 = {
        id: preloadedValues[103].id,    
        how: preloadedValues[103].how,
        howAutre: preloadedValues[103].howAutre,
        city: preloadedValues[103].city,
        sx:  preloadedValues[103].sx,
        situation: preloadedValues[103].situation,
        age: preloadedValues[103].age,
        qualification: preloadedValues[103].qualification,
        attente: preloadedValues[103].attente,
        // accept: preloadedValues[0].accept,
      };
      const user105 = {
        id: preloadedValues[104].id,    
        how: preloadedValues[104].how,
        howAutre: preloadedValues[104].howAutre,
        city: preloadedValues[104].city,
        sx:  preloadedValues[104].sx,
        situation: preloadedValues[104].situation,
        age: preloadedValues[104].age,
        qualification: preloadedValues[104].qualification,
        attente: preloadedValues[104].attente,
        // accept: preloadedValues[0].accept,
      };
      const user106 = {
        id: preloadedValues[105].id,    
        how: preloadedValues[105].how,
        howAutre: preloadedValues[105].howAutre,
        city: preloadedValues[105].city,
        sx:  preloadedValues[105].sx,
        situation: preloadedValues[105].situation,
        age: preloadedValues[105].age,
        qualification: preloadedValues[105].qualification,
        attente: preloadedValues[105].attente,
        // accept: preloadedValues[0].accept,
      };
      const user107 = {
        id: preloadedValues[106].id,    
        how: preloadedValues[106].how,
        howAutre: preloadedValues[106].howAutre,
        city: preloadedValues[106].city,
        sx:  preloadedValues[106].sx,
        situation: preloadedValues[106].situation,
        age: preloadedValues[106].age,
        qualification: preloadedValues[106].qualification,
        attente: preloadedValues[106].attente,
        // accept: preloadedValues[0].accept,
      };
      const user108 = {
        id: preloadedValues[107].id,    
        how: preloadedValues[107].how,
        howAutre: preloadedValues[107].howAutre,
        city: preloadedValues[107].city,
        sx:  preloadedValues[107].sx,
        situation: preloadedValues[107].situation,
        age: preloadedValues[107].age,
        qualification: preloadedValues[107].qualification,
        attente: preloadedValues[107].attente,
        // accept: preloadedValues[0].accept,
      };
      const user109 = {
        id: preloadedValues[108].id,    
        how: preloadedValues[108].how,
        howAutre: preloadedValues[108].howAutre,
        city: preloadedValues[108].city,
        sx:  preloadedValues[108].sx,
        situation: preloadedValues[108].situation,
        age: preloadedValues[108].age,
        qualification: preloadedValues[108].qualification,
        attente: preloadedValues[108].attente,
        // accept: preloadedValues[0].accept,
      };
      const user110 = {
        id: preloadedValues[109].id,    
        how: preloadedValues[109].how,
        howAutre: preloadedValues[109].howAutre,
        city: preloadedValues[109].city,
        sx:  preloadedValues[109].sx,
        situation: preloadedValues[109].situation,
        age: preloadedValues[109].age,
        qualification: preloadedValues[109].qualification,
        attente: preloadedValues[109].attente,
        // accept: preloadedValues[0].accept,
      };
      const user111 = {
        id: preloadedValues[110].id,    
        how: preloadedValues[110].how,
        howAutre: preloadedValues[110].howAutre,
        city: preloadedValues[110].city,
        sx:  preloadedValues[110].sx,
        situation: preloadedValues[110].situation,
        age: preloadedValues[110].age,
        qualification: preloadedValues[110].qualification,
        attente: preloadedValues[110].attente,
        // accept: preloadedValues[0].accept,
      };
      const user112 = {
        id: preloadedValues[111].id,    
        how: preloadedValues[111].how,
        howAutre: preloadedValues[111].howAutre,
        city: preloadedValues[111].city,
        sx:  preloadedValues[111].sx,
        situation: preloadedValues[111].situation,
        age: preloadedValues[111].age,
        qualification: preloadedValues[111].qualification,
        attente: preloadedValues[111].attente,
        // accept: preloadedValues[0].accept,
      };
      const user113 = {
        id: preloadedValues[112].id,    
        how: preloadedValues[112].how,
        howAutre: preloadedValues[112].howAutre,
        city: preloadedValues[112].city,
        sx:  preloadedValues[112].sx,
        situation: preloadedValues[112].situation,
        age: preloadedValues[112].age,
        qualification: preloadedValues[112].qualification,
        attente: preloadedValues[112].attente,
        // accept: preloadedValues[0].accept,
      };
      const user114 = {
        id: preloadedValues[113].id,    
        how: preloadedValues[113].how,
        howAutre: preloadedValues[113].howAutre,
        city: preloadedValues[113].city,
        sx:  preloadedValues[113].sx,
        situation: preloadedValues[113].situation,
        age: preloadedValues[113].age,
        qualification: preloadedValues[113].qualification,
        attente: preloadedValues[113].attente,
        // accept: preloadedValues[0].accept,
      };
      const user115 = {
        id: preloadedValues[114].id,    
        how: preloadedValues[114].how,
        howAutre: preloadedValues[114].howAutre,
        city: preloadedValues[114].city,
        sx:  preloadedValues[114].sx,
        situation: preloadedValues[114].situation,
        age: preloadedValues[114].age,
        qualification: preloadedValues[114].qualification,
        attente: preloadedValues[114].attente,
        // accept: preloadedValues[0].accept,
      };
      const user116 = {
        id: preloadedValues[115].id,    
        how: preloadedValues[115].how,
        howAutre: preloadedValues[115].howAutre,
        city: preloadedValues[115].city,
        sx:  preloadedValues[115].sx,
        situation: preloadedValues[115].situation,
        age: preloadedValues[115].age,
        qualification: preloadedValues[115].qualification,
        attente: preloadedValues[115].attente,
        // accept: preloadedValues[0].accept,
      };
      const user117 = {
        id: preloadedValues[116].id,    
        how: preloadedValues[116].how,
        howAutre: preloadedValues[116].howAutre,
        city: preloadedValues[116].city,
        sx:  preloadedValues[116].sx,
        situation: preloadedValues[116].situation,
        age: preloadedValues[116].age,
        qualification: preloadedValues[116].qualification,
        attente: preloadedValues[116].attente,
        // accept: preloadedValues[0].accept,
      };
      const user118 = {
        id: preloadedValues[117].id,    
        how: preloadedValues[117].how,
        howAutre: preloadedValues[117].howAutre,
        city: preloadedValues[117].city,
        sx:  preloadedValues[117].sx,
        situation: preloadedValues[117].situation,
        age: preloadedValues[117].age,
        qualification: preloadedValues[117].qualification,
        attente: preloadedValues[117].attente,
        // accept: preloadedValues[0].accept,
      };
      const user119 = {
        id: preloadedValues[118].id,    
        how: preloadedValues[118].how,
        howAutre: preloadedValues[118].howAutre,
        city: preloadedValues[118].city,
        sx:  preloadedValues[118].sx,
        situation: preloadedValues[118].situation,
        age: preloadedValues[118].age,
        qualification: preloadedValues[118].qualification,
        attente: preloadedValues[118].attente,
        // accept: preloadedValues[0].accept,
      };
      const user120 = {
        id: preloadedValues[119].id,    
        how: preloadedValues[119].how,
        howAutre: preloadedValues[119].howAutre,
        city: preloadedValues[119].city,
        sx:  preloadedValues[119].sx,
        situation: preloadedValues[119].situation,
        age: preloadedValues[119].age,
        qualification: preloadedValues[119].qualification,
        attente: preloadedValues[119].attente,
        // accept: preloadedValues[0].accept,
      };
      const user121 = {
        id: preloadedValues[120].id,    
        how: preloadedValues[120].how,
        howAutre: preloadedValues[120].howAutre,
        city: preloadedValues[120].city,
        sx:  preloadedValues[120].sx,
        situation: preloadedValues[120].situation,
        age: preloadedValues[120].age,
        qualification: preloadedValues[120].qualification,
        attente: preloadedValues[120].attente,
        // accept: preloadedValues[0].accept,
      };
      const user122 = {
        id: preloadedValues[121].id,    
        how: preloadedValues[121].how,
        howAutre: preloadedValues[121].howAutre,
        city: preloadedValues[121].city,
        sx:  preloadedValues[121].sx,
        situation: preloadedValues[121].situation,
        age: preloadedValues[121].age,
        qualification: preloadedValues[121].qualification,
        attente: preloadedValues[121].attente,
        // accept: preloadedValues[0].accept,
      };
      const user123 = {
        id: preloadedValues[122].id,    
        how: preloadedValues[122].how,
        howAutre: preloadedValues[122].howAutre,
        city: preloadedValues[122].city,
        sx:  preloadedValues[122].sx,
        situation: preloadedValues[122].situation,
        age: preloadedValues[122].age,
        qualification: preloadedValues[122].qualification,
        attente: preloadedValues[122].attente,
        // accept: preloadedValues[0].accept,
      };
      const user124 = {
        id: preloadedValues[123].id,    
        how: preloadedValues[123].how,
        howAutre: preloadedValues[123].howAutre,
        city: preloadedValues[123].city,
        sx:  preloadedValues[123].sx,
        situation: preloadedValues[123].situation,
        age: preloadedValues[123].age,
        qualification: preloadedValues[123].qualification,
        attente: preloadedValues[123].attente,
        // accept: preloadedValues[0].accept,
      };
      const user125 = {
        id: preloadedValues[124].id,    
        how: preloadedValues[124].how,
        howAutre: preloadedValues[124].howAutre,
        city: preloadedValues[124].city,
        sx:  preloadedValues[124].sx,
        situation: preloadedValues[124].situation,
        age: preloadedValues[124].age,
        qualification: preloadedValues[124].qualification,
        attente: preloadedValues[124].attente,
        // accept: preloadedValues[0].accept,
      };
      const user126 = {
        id: preloadedValues[125].id,    
        how: preloadedValues[125].how,
        howAutre: preloadedValues[125].howAutre,
        city: preloadedValues[125].city,
        sx:  preloadedValues[125].sx,
        situation: preloadedValues[125].situation,
        age: preloadedValues[125].age,
        qualification: preloadedValues[125].qualification,
        attente: preloadedValues[125].attente,
        // accept: preloadedValues[0].accept,
      };
      const user127 = {
        id: preloadedValues[126].id,    
        how: preloadedValues[126].how,
        howAutre: preloadedValues[126].howAutre,
        city: preloadedValues[126].city,
        sx:  preloadedValues[126].sx,
        situation: preloadedValues[126].situation,
        age: preloadedValues[126].age,
        qualification: preloadedValues[126].qualification,
        attente: preloadedValues[126].attente,
        // accept: preloadedValues[0].accept,
      };
      const user128 = {
        id: preloadedValues[127].id,    
        how: preloadedValues[127].how,
        howAutre: preloadedValues[127].howAutre,
        city: preloadedValues[127].city,
        sx:  preloadedValues[127].sx,
        situation: preloadedValues[127].situation,
        age: preloadedValues[127].age,
        qualification: preloadedValues[127].qualification,
        attente: preloadedValues[127].attente,
        // accept: preloadedValues[0].accept,
      };
      const user129 = {
        id: preloadedValues[128].id,    
        how: preloadedValues[128].how,
        howAutre: preloadedValues[128].howAutre,
        city: preloadedValues[128].city,
        sx:  preloadedValues[128].sx,
        situation: preloadedValues[128].situation,
        age: preloadedValues[128].age,
        qualification: preloadedValues[128].qualification,
        attente: preloadedValues[128].attente,
        // accept: preloadedValues[0].accept,
      };
      const user130 = {
        id: preloadedValues[129].id,    
        how: preloadedValues[129].how,
        howAutre: preloadedValues[129].howAutre,
        city: preloadedValues[129].city,
        sx:  preloadedValues[129].sx,
        situation: preloadedValues[129].situation,
        age: preloadedValues[129].age,
        qualification: preloadedValues[129].qualification,
        attente: preloadedValues[129].attente,
        // accept: preloadedValues[0].accept,
      };
      const user131 = {
        id: preloadedValues[130].id,    
        how: preloadedValues[130].how,
        howAutre: preloadedValues[130].howAutre,
        city: preloadedValues[130].city,
        sx:  preloadedValues[130].sx,
        situation: preloadedValues[130].situation,
        age: preloadedValues[130].age,
        qualification: preloadedValues[130].qualification,
        attente: preloadedValues[130].attente,
        // accept: preloadedValues[0].accept,
      };
      const user132 = {
        id: preloadedValues[131].id,    
        how: preloadedValues[131].how,
        howAutre: preloadedValues[131].howAutre,
        city: preloadedValues[131].city,
        sx:  preloadedValues[131].sx,
        situation: preloadedValues[131].situation,
        age: preloadedValues[131].age,
        qualification: preloadedValues[131].qualification,
        attente: preloadedValues[131].attente,
        // accept: preloadedValues[0].accept,
      };
      const user133 = {
        id: preloadedValues[132].id,    
        how: preloadedValues[132].how,
        howAutre: preloadedValues[132].howAutre,
        city: preloadedValues[132].city,
        sx:  preloadedValues[132].sx,
        situation: preloadedValues[132].situation,
        age: preloadedValues[132].age,
        qualification: preloadedValues[132].qualification,
        attente: preloadedValues[132].attente,
        // accept: preloadedValues[0].accept,
      };
      const user134 = {
        id: preloadedValues[133].id,    
        how: preloadedValues[133].how,
        howAutre: preloadedValues[133].howAutre,
        city: preloadedValues[133].city,
        sx:  preloadedValues[133].sx,
        situation: preloadedValues[133].situation,
        age: preloadedValues[133].age,
        qualification: preloadedValues[133].qualification,
        attente: preloadedValues[133].attente,
        // accept: preloadedValues[0].accept,
      };
      const user135 = {
        id: preloadedValues[134].id,    
        how: preloadedValues[134].how,
        howAutre: preloadedValues[134].howAutre,
        city: preloadedValues[134].city,
        sx:  preloadedValues[134].sx,
        situation: preloadedValues[134].situation,
        age: preloadedValues[134].age,
        qualification: preloadedValues[134].qualification,
        attente: preloadedValues[134].attente,
        // accept: preloadedValues[0].accept,
      };
      const user136 = {
        id: preloadedValues[135].id,    
        how: preloadedValues[135].how,
        howAutre: preloadedValues[135].howAutre,
        city: preloadedValues[135].city,
        sx:  preloadedValues[135].sx,
        situation: preloadedValues[135].situation,
        age: preloadedValues[135].age,
        qualification: preloadedValues[135].qualification,
        attente: preloadedValues[135].attente,
        // accept: preloadedValues[0].accept,
      };
      const user137 = {
        id: preloadedValues[136].id,    
        how: preloadedValues[136].how,
        howAutre: preloadedValues[136].howAutre,
        city: preloadedValues[136].city,
        sx:  preloadedValues[136].sx,
        situation: preloadedValues[136].situation,
        age: preloadedValues[136].age,
        qualification: preloadedValues[136].qualification,
        attente: preloadedValues[136].attente,
        // accept: preloadedValues[0].accept,
      };
      const user138 = {
        id: preloadedValues[137].id,    
        how: preloadedValues[137].how,
        howAutre: preloadedValues[137].howAutre,
        city: preloadedValues[137].city,
        sx:  preloadedValues[137].sx,
        situation: preloadedValues[137].situation,
        age: preloadedValues[137].age,
        qualification: preloadedValues[137].qualification,
        attente: preloadedValues[137].attente,
        // accept: preloadedValues[0].accept,
      };
      const user139 = {
        id: preloadedValues[138].id,    
        how: preloadedValues[138].how,
        howAutre: preloadedValues[138].howAutre,
        city: preloadedValues[138].city,
        sx:  preloadedValues[138].sx,
        situation: preloadedValues[138].situation,
        age: preloadedValues[138].age,
        qualification: preloadedValues[138].qualification,
        attente: preloadedValues[138].attente,
        // accept: preloadedValues[0].accept,
      };
      const user140 = {
        id: preloadedValues[139].id,    
        how: preloadedValues[139].how,
        howAutre: preloadedValues[139].howAutre,
        city: preloadedValues[139].city,
        sx:  preloadedValues[139].sx,
        situation: preloadedValues[139].situation,
        age: preloadedValues[139].age,
        qualification: preloadedValues[139].qualification,
        attente: preloadedValues[139].attente,
        // accept: preloadedValues[0].accept,
      };

      useEffect(() =>  {

        if(mailIsChecked === preloadedValues[0].email) {
             setActiveUser(user1)
          }   
        if(mailIsChecked === preloadedValues[1].email) {
             setActiveUser(user2)
          }   
        if(mailIsChecked === preloadedValues[2].email) {
             setActiveUser(user3)
          }   
        if(mailIsChecked === preloadedValues[3].email) {
             setActiveUser(user4)
          }   
        if(mailIsChecked === preloadedValues[4].email) {
             setActiveUser(user5)
          }   
        if(mailIsChecked === preloadedValues[5].email) {
             setActiveUser(user6)
          }   
        if(mailIsChecked === preloadedValues[6].email) {
             setActiveUser(user7)
          }   
        if(mailIsChecked === preloadedValues[7].email) {
             setActiveUser(user8)
          }   
        if(mailIsChecked === preloadedValues[8].email) {
             setActiveUser(user9)
          }   
        if(mailIsChecked === preloadedValues[9].email) {
             setActiveUser(user10)
          }   
        if(mailIsChecked === preloadedValues[10].email) {
             setActiveUser(user11)
          }   
        if(mailIsChecked === preloadedValues[11].email) {
             setActiveUser(user12)
          }   
        if(mailIsChecked === preloadedValues[12].email) {
             setActiveUser(user13)
          }   
        if(mailIsChecked === preloadedValues[13].email) {
             setActiveUser(user14)
          }   
        if(mailIsChecked === preloadedValues[14].email) {
             setActiveUser(user15)
          }   
        if(mailIsChecked === preloadedValues[15].email) {
             setActiveUser(user16)
          }   
        if(mailIsChecked === preloadedValues[16].email) {
             setActiveUser(user17)
          }   
        if(mailIsChecked === preloadedValues[17].email) {
             setActiveUser(user18)
          }   
        if(mailIsChecked === preloadedValues[18].email) {
             setActiveUser(user19)
          }   
        if(mailIsChecked === preloadedValues[19].email) {
             setActiveUser(user20)
          }   
        if(mailIsChecked === preloadedValues[20].email) {
             setActiveUser(user21)
          }   
        if(mailIsChecked === preloadedValues[21].email) {
             setActiveUser(user22)
          }   
        if(mailIsChecked === preloadedValues[22].email) {
             setActiveUser(user23)
          }   
        if(mailIsChecked === preloadedValues[23].email) {
             setActiveUser(user24)
          }   
        if(mailIsChecked === preloadedValues[24].email) {
             setActiveUser(user25)
          }   
        if(mailIsChecked === preloadedValues[25].email) {
             setActiveUser(user26)
          }   
        if(mailIsChecked === preloadedValues[26].email) {
             setActiveUser(user27)
          }   
        if(mailIsChecked === preloadedValues[27].email) {
             setActiveUser(user28)
          }   
        if(mailIsChecked === preloadedValues[28].email) {
             setActiveUser(user29)
          }   
        if(mailIsChecked === preloadedValues[29].email) {
             setActiveUser(user30)
          }   
        if(mailIsChecked === preloadedValues[30].email) {
             setActiveUser(user31)
          }   
        if(mailIsChecked === preloadedValues[31].email) {
             setActiveUser(user32)
          }   
        if(mailIsChecked === preloadedValues[32].email) {
             setActiveUser(user33)
          }   
        if(mailIsChecked === preloadedValues[33].email) {
             setActiveUser(user34)
          }   
        if(mailIsChecked === preloadedValues[34].email) {
             setActiveUser(user35)
          }   
        if(mailIsChecked === preloadedValues[35].email) {
             setActiveUser(user36)
          }   
        if(mailIsChecked === preloadedValues[36].email) {
             setActiveUser(user37)
          }   
        if(mailIsChecked === preloadedValues[37].email) {
             setActiveUser(user38)
          }   
        if(mailIsChecked === preloadedValues[38].email) {
             setActiveUser(user39)
          }   
        if(mailIsChecked === preloadedValues[39].email) {
             setActiveUser(user40)
          }   
        if(mailIsChecked === preloadedValues[40].email) {
             setActiveUser(user41)
          }   
        if(mailIsChecked === preloadedValues[41].email) {
             setActiveUser(user42)
          }   
        if(mailIsChecked === preloadedValues[42].email) {
             setActiveUser(user43)
          }   
        if(mailIsChecked === preloadedValues[43].email) {
             setActiveUser(user44)
          }   
        if(mailIsChecked === preloadedValues[44].email) {
             setActiveUser(user45)
          }   
        if(mailIsChecked === preloadedValues[45].email) {
             setActiveUser(user46)
          }   
        if(mailIsChecked === preloadedValues[46].email) {
             setActiveUser(user47)
          }   
        if(mailIsChecked === preloadedValues[47].email) {
             setActiveUser(user48)
          }   
        if(mailIsChecked === preloadedValues[48].email) {
             setActiveUser(user49)
          }   
        if(mailIsChecked === preloadedValues[49].email) {
             setActiveUser(user50)
          }   
        if(mailIsChecked === preloadedValues[50].email) {
             setActiveUser(user51)
          }   
        if(mailIsChecked === preloadedValues[51].email) {
             setActiveUser(user52)
          }   
        if(mailIsChecked === preloadedValues[52].email) {
             setActiveUser(user53)
          }   
        if(mailIsChecked === preloadedValues[54].email) {
             setActiveUser(user54)
          }   
        if(mailIsChecked === preloadedValues[55].email) {
             setActiveUser(user55)
          }   
        if(mailIsChecked === preloadedValues[56].email) {
             setActiveUser(user57)
          }   
        if(mailIsChecked === preloadedValues[57].email) {
             setActiveUser(user58)
          }   
        if(mailIsChecked === preloadedValues[58].email) {
             setActiveUser(user59)
          }   
        if(mailIsChecked === preloadedValues[59].email) {
             setActiveUser(user60)
          }   
        if(mailIsChecked === preloadedValues[60].email) {
             setActiveUser(user61)
          }   
        if(mailIsChecked === preloadedValues[61].email) {
             setActiveUser(user62)
          }   
        if(mailIsChecked === preloadedValues[62].email) {
             setActiveUser(user63)
          }   
        if(mailIsChecked === preloadedValues[63].email) {
             setActiveUser(user64)
          }   
        if(mailIsChecked === preloadedValues[64].email) {
             setActiveUser(user65)
          }   
        if(mailIsChecked === preloadedValues[65].email) {
             setActiveUser(user66)
          }   
        if(mailIsChecked === preloadedValues[66].email) {
             setActiveUser(user67)
          }   
        if(mailIsChecked === preloadedValues[67].email) {
             setActiveUser(user68)
          }   
        if(mailIsChecked === preloadedValues[68].email) {
             setActiveUser(user69)
          }   
        if(mailIsChecked === preloadedValues[69].email) {
             setActiveUser(user70)
          }   
        if(mailIsChecked === preloadedValues[70].email) {
             setActiveUser(user71)
          }   
        if(mailIsChecked === preloadedValues[71].email) {
             setActiveUser(user72)
          }   
        if(mailIsChecked === preloadedValues[72].email) {
             setActiveUser(user73)
          }   
        if(mailIsChecked === preloadedValues[73].email) {
             setActiveUser(user74)
          }   
        if(mailIsChecked === preloadedValues[74].email) {
             setActiveUser(user75)
          }   
        if(mailIsChecked === preloadedValues[75].email) {
             setActiveUser(user76)
          }   
        if(mailIsChecked === preloadedValues[76].email) {
             setActiveUser(user77)
          }   
        if(mailIsChecked === preloadedValues[77].email) {
             setActiveUser(user78)
          }   
        if(mailIsChecked === preloadedValues[78].email) {
             setActiveUser(user79)
          }   
        if(mailIsChecked === preloadedValues[79].email) {
             setActiveUser(user80)
          }   
        if(mailIsChecked === preloadedValues[80].email) {
             setActiveUser(user81)
          }   
        if(mailIsChecked === preloadedValues[81].email) {
             setActiveUser(user82)
          }   
        if(mailIsChecked === preloadedValues[82].email) {
             setActiveUser(user83)
          }   
        if(mailIsChecked === preloadedValues[83].email) {
             setActiveUser(user84)
          }   
        if(mailIsChecked === preloadedValues[84].email) {
             setActiveUser(user85)
          }   
        if(mailIsChecked === preloadedValues[85].email) {
             setActiveUser(user86)
          }   
        if(mailIsChecked === preloadedValues[86].email) {
             setActiveUser(user87)
          }   
        if(mailIsChecked === preloadedValues[87].email) {
             setActiveUser(user88)
          }   
        if(mailIsChecked === preloadedValues[88].email) {
             setActiveUser(user89)
          }   
        if(mailIsChecked === preloadedValues[89].email) {
             setActiveUser(user90)
          }   
        if(mailIsChecked === preloadedValues[90].email) {
             setActiveUser(user91)
          }   
        if(mailIsChecked === preloadedValues[91].email) {
             setActiveUser(user92)
          }   
        if(mailIsChecked === preloadedValues[92].email) {
             setActiveUser(user93)
          }   
        if(mailIsChecked === preloadedValues[93].email) {
             setActiveUser(user94)
          }   
        if(mailIsChecked === preloadedValues[94].email) {
             setActiveUser(user95)
          }   
        if(mailIsChecked === preloadedValues[95].email) {
             setActiveUser(user96)
          }   
        if(mailIsChecked === preloadedValues[96].email) {
             setActiveUser(user97)
          }   
        if(mailIsChecked === preloadedValues[97].email) {
             setActiveUser(user98)
          }   
        if(mailIsChecked === preloadedValues[98].email) {
             setActiveUser(user99)
          }   
        if(mailIsChecked === preloadedValues[99].email) {
             setActiveUser(user100)
          }   
        if(mailIsChecked === preloadedValues[100].email) {
             setActiveUser(user101)
          }   
        if(mailIsChecked === preloadedValues[101].email) {
             setActiveUser(user102)
          }   
        if(mailIsChecked === preloadedValues[102].email) {
             setActiveUser(user103)
          }   
        if(mailIsChecked === preloadedValues[103].email) {
             setActiveUser(user104)
          }   
        if(mailIsChecked === preloadedValues[104].email) {
             setActiveUser(user105)
          }   
        if(mailIsChecked === preloadedValues[105].email) {
             setActiveUser(user106)
          }   
        if(mailIsChecked === preloadedValues[106].email) {
             setActiveUser(user107)
          }   
        if(mailIsChecked === preloadedValues[107].email) {
             setActiveUser(user108)
          }   
        if(mailIsChecked === preloadedValues[108].email) {
             setActiveUser(user109)
          }   
        if(mailIsChecked === preloadedValues[109].email) {
             setActiveUser(user110)
          }   
        if(mailIsChecked === preloadedValues[110].email) {
             setActiveUser(user111)
          }   
        if(mailIsChecked === preloadedValues[111].email) {
             setActiveUser(user112)
          }   
        if(mailIsChecked === preloadedValues[112].email) {
             setActiveUser(user113)
          }   
        if(mailIsChecked === preloadedValues[113].email) {
             setActiveUser(user114)
          }   
        if(mailIsChecked === preloadedValues[114].email) {
             setActiveUser(user115)
          }   
        if(mailIsChecked === preloadedValues[115].email) {
             setActiveUser(user116)
          }   
        if(mailIsChecked === preloadedValues[116].email) {
             setActiveUser(user117)
          }   
        if(mailIsChecked === preloadedValues[117].email) {
             setActiveUser(user118)
          }   
        if(mailIsChecked === preloadedValues[118].email) {
             setActiveUser(user119)
          }   
        if(mailIsChecked === preloadedValues[119].email) {
             setActiveUser(user120)
          }   
        if(mailIsChecked === preloadedValues[120].email) {
             setActiveUser(user121)
          }   
        if(mailIsChecked === preloadedValues[121].email) {
             setActiveUser(user122)
          }   
        if(mailIsChecked === preloadedValues[122].email) {
             setActiveUser(user123)
          }   
        if(mailIsChecked === preloadedValues[123].email) {
             setActiveUser(user124)
          }   
        if(mailIsChecked === preloadedValues[124].email) {
             setActiveUser(user125)
          }   
        if(mailIsChecked === preloadedValues[125].email) {
             setActiveUser(user126)
          }   
        if(mailIsChecked === preloadedValues[126].email) {
             setActiveUser(user127)
          }   
        if(mailIsChecked === preloadedValues[127].email) {
             setActiveUser(user128)
          }   
        if(mailIsChecked === preloadedValues[128].email) {
             setActiveUser(user129)
          }   
        if(mailIsChecked === preloadedValues[129].email) {
             setActiveUser(user130)
          }   
        if(mailIsChecked === preloadedValues[130].email) {
             setActiveUser(user131)
          }   
        if(mailIsChecked === preloadedValues[131].email) {
             setActiveUser(user132)
          }   
        if(mailIsChecked === preloadedValues[132].email) {
             setActiveUser(user133)
          }   
        if(mailIsChecked === preloadedValues[133].email) {
             setActiveUser(user134)
          }   
        if(mailIsChecked === preloadedValues[134].email) {
             setActiveUser(user135)
          }   
        if(mailIsChecked === preloadedValues[135].email) {
             setActiveUser(user136)
          }   
        if(mailIsChecked === preloadedValues[136].email) {
             setActiveUser(user137)
          }   
        if(mailIsChecked === preloadedValues[137].email) {
             setActiveUser(user138)
          }   
        if(mailIsChecked === preloadedValues[138].email) {
             setActiveUser(user139)
          }   
        if(mailIsChecked === preloadedValues[139].email) {
             setActiveUser(user140)
          }   
   }, [mailIsChecked]);

   
      useEffect(() => {
        reset(activeUser);
    }, [activeUser]);


 


      const handleHowOption = (e) => {
          if(e.target.checked) {
            setIsSelectedOne(true)
          } else {
            setIsSelectedOne(false)
          }
   
      }

      const mailCheckHandler = async data => { 
        return new Promise((resolve) => { 
          setTimeout(() => { 
            setmailChecked(data.mailCheck.toLowerCase())
            if (mailIsChecked === null){
               setShowForm(false)
            } else setShowForm(true)                              
            resolve()
            setShowmailChecker(false)
            mailCheckRef.current.reset()
         
       }, 1000)
     })
  }

      const handleReturn = () => { 
        setShowForm(false) 
        setShowQuestionBox(true)    
        setValidation([""])      

    }

        const handleReturnChecker = () => { 
          setShowmailChecker(false)
          setShowQuestionBox(true)
        }

        const [showForm, setShowForm] = useState(false);

        const [showQuestionBox, setShowQuestionBox] = useState(true);
        
        const [showmailChecker, setShowmailChecker] = useState(false)
      
        
        useEffect(() => {
          if (showForm === true) {
            setTimeout(() => {
           
  
            }, 1000)
          } else {
          }
          console.log(showForm)
      }, [showForm]);
  

      const radioHandler = data => {

        if (data.preSignUp === "oui") {
          setShowmailChecker(true)
          setShowQuestionBox(false)
        } else if (data.preSignUp === "non") {
          setShowmailChecker(false)
          setShowForm(true)
          setShowQuestionBox(false)
          setActiveUser(null)
        }  

        console.log(data.preSignUp)
  } 

      const handleSituationOption = (e) => {
          if(e.target.checked) {
            setIsSelectedTwo(true)
          } else {
            setIsSelectedTwo(false)
          }
    
      }

      const handleSituation = (e) => {
          if(e.target.checked) {
            setIsSelectedThree(true)
          } else {
            setIsSelectedThree(false)
          }
        
      }
      
      useEffect(() => {
        console.log(validation)
      }, [validation])
      const onSubmit = async data  => {

            var how = ["Non renseigné"];
            var howAutre = "";
            var city = "Non renseigné";
            var sx = "Non renseigné";
            var situation = ["Non renseigné"];
            var situationAutre = "";
            var age = "Non renseigné";
            var qualification = "Non renseigné";
            var attente = "Non renseigné";
            var accept = "/";
           
            var village = ["Non renseigné"];     
            var questions = "Non renseigné";     
            var why = "/";     
            var suite = ["Non renseigné"];     
            var suiteAutre = "/";     
            var satisfaction = "Non renseigné";
            var newEdition = "Non renseigné";
           

            
            function randomIntFromInterval(min, max) { // min and max included 
              return Math.floor(Math.random() * (max - min + 1) + min)
            }
            
            const autoGeneratedId = randomIntFromInterval(80, 1000)
            
          if(data.village) {
                village = data.village
          }
            
          if(data.questions) {
                questions = data.questions
          }
    
          if(data.why) {
                why = data.why
          }
            
          if(data.suite) {
                suite = data.suite
          }

          if(data.suiteAutre) {
                suiteAutre = data.suiteAutre
          }
    
          if(data.satisfaction) {
                satisfaction = data.satisfaction
          }
    
          if(data.newEdition) {
                newEdition = data.newEdition
          } 

          if(data.how) {
            how = data.how
          }

          if(data.city) {
            city = data.city
          } 
                    
          if(data.sx) {
            sx = data.sx
          } 
                    
          if(data.situation) {
            situation = data.situation
          } 
                    
          if(data.age) {
            age = data.age
          } 
                    
          if(data.qualification) {
            qualification = data.qualification
          } 
                    
          if(data.attente) {
            attente = data.attente
          } 
                    
          if(data.accept) {
            accept = data.accept
          } 
          if(data.howAutre) {
            howAutre = data.howAutre
          } 
          if(data.situationAutre) {
            situationAutre = data.situationAutre
          } 

        try {

       
            const preSubInfo = {
              ID: autoGeneratedId,
              HOW: how,
              AUTRESOURCES: howAutre,
              CITY: city,
              SX: sx,
              SITUATION: situation,
              AUTRESITUATION: situationAutre,
              AGE: age,
              QUALIFICATION: qualification,
              ATTENTE: attente,
              ACCEPT: accept,
              VILLAGE: village,
              QUESTIONS: questions,
              WHY: why,
              SUITE: suite,
              SUITEAUTRE: suiteAutre,
              SATISFACTION: satisfaction,
              NEWEDITION: newEdition,   
              DATE: new Date().toLocaleString()         
            }
            console.log(preSubInfo)
            console.log(data)
            const ref = collection(db, "visitorSatisfactionForm");
            const docRef = addDoc(ref, preSubInfo)
            setValidation(["Vos réponses ont bien été enregistrées !", "Success"])
  

          }
                  catch(err) {
                  console.log(err);
                  setValidation(["Une erreur s'est produite veuillez rééssayer ultérieurement", "Error"])
    
              }
        

          
             
          
              formRef.current.reset();
              window.scrollTo(0, 0)
              setTimeout(() => {
                window.location.reload();
              }, 5000)
              
    }
      
            return (

              <div> 
             
             { showQuestionBox ? (    
                     <form className="box" onSubmit={handleSubmit(radioHandler)}>
         
                        <h3>Êtes-vous pré-inscrit(e)</h3>
                        <h3>à ce Carrefour ?</h3>
                
                        <div className="row">
                          <input type="radio" value="oui" name='preSignUp' {...register('preSignUp')}/><label htmlFor="preSignUp">Oui</label>
                          <input type="radio" value="non" name='preSignUp' {...register('preSignUp')}/><label htmlFor="preSignUp">Non</label>
                        </div>
                        <button className="btn" >Valider</button>
                       
                    </form>
                    
                    ) : <div></div>
                 } 
          
                  
                  { showmailChecker ?  (    
                      <form ref={mailCheckRef} className={isSubmitting ? "mailChecker_loading" : "mailChecker"} onSubmit={handleSubmit(mailCheckHandler)}>
                      <div className='backMC' onClick={handleReturnChecker}><BiArrowBack /></div>
                      <h2>Entrer votre adresse email</h2> 
                      <input id="mailCheck" type="mail" placeholder='xyz@example.fr' {...register('mailCheck')}/>
                      <button className='validate'>Valider</button>
                     </form>
                  ) :  <div></div>
             
                 }  
    
                    {isSubmitting && (
                      <div className="loader"></div>
                    )} 
             { showForm ? ( 
              <>                     
                      <div className='back' onClick={handleReturn}><BiArrowBack /> Retour</div>
                      {validation && <div className={ validation[1] === "Success" ? "success" : validation === "Error" ? "error" : "none"}>{validation[0]}</div> }  
                      
                      <form ref={formRef} id="sign-in" onSubmit={handleSubmit(onSubmit)}>
               

                        <label>Comment avez-vous été informé.e de ce forum ?</label>
                        <div className="how">
                            <div className='row'>
                                  <input {...register('how')} value="Internet, réseaux sociaux" name="how" type='checkbox'></input>
                                  <label>Internet, réseaux sociaux</label>
                            </div>
                            <div className='row'>
                                  <input {...register('how')} value="Flyer ou affiche" name="how" type='checkbox'></input>
                                  <label>Flyer ou affiche</label>
                            </div>
                            <div className='row'>
                                  <input {...register('how')} value="Radio" name="how" type='checkbox'></input>
                                  <label>Radio</label>
                            </div>
                            <div className='row'>
                                  <input {...register('how')} value="Par un conseiller" name="how" type='checkbox'></input>
                                  <label>Par un conseiller</label>
                            </div>

                            <div className='row'>
                                  <input {...register('how')} value="Autre" onChange={handleHowOption} name="how" type='checkbox'></input>
                                  <label>Autre (précisez) :</label>
                                  {isSelectedOne === true ? (<input  {...register('howAutre')} name="howAutre" type="text" id="" />) : <input  {...register('howAutre')} name="howAutre" type="text" id="" disabled/>}
                            </div>
                        </div>
                       

                        <label htmlFor="name">Votre ville de Résidence</label>
                          <input {...register('city')} type="text" ></input>
            
            
                        <label>Sexe</label>
                        <div className="sx">
                          <div className='row'>
                                <input {...register('sx')} type='radio' value='Femme'></input>
                                <label>Femme</label>
                          </div>
                          <div className='row'>
                                <input {...register('sx')}  type='radio' value='Homme'></input>
                                <label>Homme</label>
                          </div>
                        </div>
                       
                        <label htmlFor="how">Votre situation actuelle :</label>
                        <div className="situation">
                          <div className='row'>
                                <input {...register('situation')} name="situation" value="Scolaire, Étudiant.e" type='checkbox'></input>
                                <label>Scolaire, Étudiant.e</label>
                          </div>
                          <div className='row'>
                                <input {...register('situation')} name="situation" value="Salarié.e" type='checkbox'></input>
                                <label>Salarié.e</label>
                          </div>
                          <div className='row'>
                                <input {...register('situation')} name="situation" value="Bénéficiaire minima sociaux" type='checkbox'></input>
                                <label>Bénéficiaire minima sociaux</label>
                          </div>
                          <div className='row'>
                                <input {...register('situation')} name="situation" value="Demandeur.se d'emploi" type='checkbox'></input>
                                <label>Demandeur.se d'emploi</label>
                          </div>
                          <div className='row'>
                                <input {...register('situation')} name="situation" value="En formation professionnelle" type='checkbox'></input>
                                <label>En formation professionnelle</label>
                          </div>
                          <div className='row'>
                                <input {...register('situation')} name="situation" value="Retraité.e" type='checkbox'></input>
                                <label>Retraité.e</label>
                          </div>

                          <div className='row'>
                                <input {...register('situation')} name="situation" onChange={handleSituationOption} value="Autre" type='checkbox'></input>
                                <label>Autre (précisez) :</label>
                                {isSelectedTwo === true ? ( <input  {...register('situationAutre')} name="situationAutre" type="text" id="" />) :  <input  {...register('situationAutre')} name="situationAutre" type="text" id="" disabled/>}
                               
                          </div>
                        </div>
              
                      
                        <label>Votre âge :</label>
                        <div className='radio'>
                           <div className='row'>
                              <input {...register('age')} value="- de 16 ans" name="age" type='radio'></input>
                              <label> - de 16 ans</label>
                           </div>
                           <div className="row">
                              <input {...register('age')} value="16-25 ans" name="age" type='radio'></input>
                              <label>16-25 ans</label>
                           </div>
                           <div className="row">
                              <input {...register('age')} value="26-44 ans" name="age" type='radio'></input>
                              <label>26-44 ans</label>
                           </div>
                           <div className="row">
                              <input {...register('age')} value="45 ans et +" name="age" type='radio'></input>
                              <label>45 ans et +</label>
                           </div>
                        </div>  
                      

                    
                        <label>Votre niveau de qualification</label>
                        <div className="qualification">
                            <div className="row">
                                <input {...register('qualification')} value="Infra bac" name="qualification" type='radio'></input>
                                <label>Infra bac</label>
                            </div>
                            <div className="row">
                                <input {...register('qualification')} value="Bac" name="qualification" type='radio'></input>
                                <label>Bac</label>
                            </div>
                            <div className="row">
                                <input {...register('qualification')}  value="Post bac" name="qualification" type='radio'></input>
                                <label >Post bac</label>
                            </div>
                        </div>
                        <label>Quelle est votre attente sur ce salon ?</label>
                        <div className="attente">
                          <div className='row'>
                                <input {...register('attente')} name="attente" type='checkbox' value="Aide sur votre orientation"></input>
                                <label>Aide sur votre orientation</label>
                          </div>
                          <div className="row">
                                  <input {...register('attente')} name="attente" type='checkbox' value="Trouver une formation"></input>
                                  <label>Trouver une formation</label>
                          </div>
                          <div className="row">
                                  <input {...register('attente')} name="attente" type='checkbox' value="Trouver un emploi"></input>
                                  <label>Trouver un emploi</label>
                          </div>
                          <div className="row">
                                  <input {...register('attente')} name="attente" type='checkbox' value="Aide dans votre reconversin professionelle"></input>
                                  <label>Aide dans votre reconversion professionnelle</label>
                          </div>
                          <div className="row">
                                  <input {...register('attente')} name="attente" type='checkbox' value="Chercher des informations sur les métiers porteurs"></input>
                                  <label>Chercher des informations sur les métiers porteurs</label>
                          </div>
                              
                        </div>


                        <hr />

                        <label>Quels villages avez-vous visités ?</label>
                             <div className="village">
                                <div className='row'>
                                      <input {...register('village')} name="village" value="Village recrutement" type='checkbox'></input>
                                      <label>Village recrutement</label>
                                </div>
                                <div className='row'>
                                      <input {...register('village')} name="village" value="Village formation" type='checkbox'></input>
                                      <label>Village formation</label>
                                </div>
                                <div className='row'>
                                      <input {...register('village')} name="village" value="Village information" type='checkbox'></input>
                                      <label>Village information</label>
                                </div>
                                <div className='row'>
                                      <input {...register('village')} name="village" value="Village orientation/reconversion" type='checkbox'></input>
                                      <label>Village orientation/reconversion</label>
                                </div>
                                <div className='row'>
                                      <input {...register('village')} name="village" value="Conférences" type='checkbox'></input>
                                      <label>Conférences</label>
                                </div>
                                <div className='row'>
                                      <input {...register('village')} name="village" value="Jobs dating" type='checkbox'></input>
                                      <label>Jobs dating</label>
                                </div>
                             </div>
                             <label>Avez-vous eu les réponses à vos questions :</label>
                              <div className='row'>
                                      <input {...register('questions')} name="questions" value="Oui" type='radio'></input>
                                      <label>Oui</label>
                              </div>
                              <div className='row'>
                                      <input {...register('questions')} name="questions" value="Non" type='radio'></input>
                                      <label>Non</label>
                              </div>
                              <label>Pourquoi ?</label>
                              <textarea {...register('why')} name="why" id="" cols="30" rows="2"></textarea>
                              <label>Quelle suite donnerez-vous à ce Carrefour ?</label>
                              <div className="suite">
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="Inscription à une formation" type='checkbox'></input>
                                      <label>Inscription à une formation</label>
                                </div>
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="Entretien d'embauche" type='checkbox'></input>
                                      <label>Entretien d'embauche</label>
                                </div>
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="Candidature à une offre" type='checkbox'></input>
                                      <label>Candidature à une offre</label>
                                </div>
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="RDV avec un professionnel pour un accompagnement" type='checkbox'></input>
                                      <label>RDV avec un professionnel pour un accompagnement</label>
                                </div>
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="Conférences" type='checkbox'></input>
                                      <label>Stage de découverte métiers</label>
                                </div>
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="Jobs dating" type='checkbox'></input>
                                      <label>Création d'activité</label>
                                </div>
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="Autre situation" onChange={handleSituation} type='checkbox'></input>
                                      <label>Autre situation</label>
                                     { isSelectedThree === true ? (<input {...register('suiteAutre')} name="suiteAutre" type='text'></input>) : <input {...register('suiteAutre')} name="suiteAutre" type='text' disabled></input>} 
                                </div>
                             </div>
                             <label>Quel est votre niveau de satisfaction générale sur ce Carrefour ?</label>
                             <div className="suite">
                                <div className='row'>
                                      <input {...register('satisfaction')} name="satisfaction" value="Insatisfait.e" type='radio'></input>
                                      <label>Insatisfait.e</label>
                                </div>
                                <div className='row'>
                                      <input {...register('satisfaction')} name="satisfaction" value="Peu satisfait.e" type='radio'></input>
                                      <label>Peu satisfait.e</label>
                                </div>
                                <div className='row'>
                                      <input {...register('satisfaction')} name="satisfaction" value="Satisfait.e" type='radio'></input>
                                      <label>Satisfait.e</label>
                                </div>
                                <div className='row'>
                                      <input {...register('satisfaction')} name="satisfaction" value="Très satisfait.e" type='radio'></input>
                                      <label>Très satisfait.e</label>
                                </div>
                             </div>
                                <label>Si une nouvelle édition est organisée en 2024, que souhaiteriez-vous y trouver ?<br /> Avez-vous des suggestions d'amélioration</label>
                                <textarea {...register('newEdition')} name="newEdition" id="" cols="30" rows="10"></textarea>
                                <div className="thanks">
                                  <h3>Merci de votre participation !</h3>
                                </div>
                        
                <div className="infoBox">

                        <p>Vous êtes informés de la collecte de données à caractère personnel par la CCI du Territoire de Belfort et la MIFE.<br /><br />
                        Le traitement de ces données a pour finalité :</p>
                        <ul>
                          <li>1- Informations sur les aides apportées par les partenaires</li>
                          <li>2- Invitations et informations sur les événements organisés par la CCI90 et MIFE90</li>
                          <li>3- Bilan de l’action.</li>
                        </ul>
                        <br />
                        <p>Ce traitement est fondé juridiquement sur l’art. 6 du Règlement Général sur la Protection des Données UE/2016/679, paragraphe 1, point e) : Mission de service public
                           Les destinataires de ces données à caractère personnel sont les collaborateurs du service de la CCI90 et la MIFE.
                           Vous disposez d’un droit d’accès, de rectification, d’effacement ou d’opposition et de portabilité de vos données, que vous pouvez exercer à l’adresse susmentionnée ou par courriel à RGPD@bfc.cci.fr
                           Vous disposez également d’un droit de réclamation auprès de la CNIL , 3 place Fontenoy – TSA 80715 – 75334 PARIS CEDEX 07.

                           <br /><br />Ces données seront conservées jusqu’au 31 décembre 2023.</p>
                           <div className="row">
                               <input {...register('accept')} type="checkbox" value="J'ai pris connaissance de cette information" name="accept" required id=""/>
                               <label>J'ai pris connaissance de cette information</label>
                               <strong className='aste'>*</strong>
                          </div>
                          
                </div>

                
                       
                       
                 

                              <button  disabled={isSubmitting}  className="btn" id="button">Envoyer</button>
                        </form>
                     

                        </> ) : "" }

                  
                 
                  </div>

              );
          };

export default Form;

    